import {
  Box,
  StepLabel,
  Stepper as MuiStepper,
  Step,
  Stack,
  Typography,
} from "@mui/material";
import { AnonymousPaymentStepConnector } from "./AnonymousPaymentStepConnector";
import { AnonymousPaymentStepIcon } from "./AnonymousPaymentStepIcon";
import {
  PAYMENT_STEPS,
  type PaymentStep,
} from "Components/AnonymousCustomer/Payment/config";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.CustomerAnonymousPaymentPay.Steps;

type Props = {
  activeStep: PaymentStep;
  hasError?: boolean;
  isAllDone?: boolean;
};

export const AnonymousPaymentStepper = ({
  activeStep,
  hasError = false,
}: Props) => {
  const { t } = useResource();

  const activeStepIndex = PAYMENT_STEPS.indexOf(activeStep);

  return (
    <Stack gap={4} width="100%">
      <Typography variant="h3" fontWeight={600} textAlign="center">
        {t(RESOURCES[activeStep])}
      </Typography>
      <Box component="nav" aria-label="Progress" width="100%">
        <MuiStepper
          alternativeLabel
          activeStep={activeStepIndex}
          connector={<AnonymousPaymentStepConnector />}
        >
          {PAYMENT_STEPS.map((step) => (
            <Step
              key={step}
              completed={activeStepIndex > PAYMENT_STEPS.indexOf(step)}
            >
              <StepLabel
                slots={{
                  stepIcon: (props) => (
                    <AnonymousPaymentStepIcon
                      {...props}
                      step={step}
                      hasError={hasError}
                    />
                  ),
                }}
              />
            </Step>
          ))}
        </MuiStepper>
      </Box>
    </Stack>
  );
};
